import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef} from '@angular/material';

// Imports Application
import { DContextoMuisca, DLogger } from '@dian/core';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DEnvioLogComponente } from '@dian-cmp/envio-log';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DObserverTimerSessionApp } from './configuracion/dformulario-configuracion';
import { MessageService } from './resources/services/message.service';
import { environment } from './../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    DContextoUsuarioServicio,
    DNotificacionServicio
  ]
})
export class AppComponent implements OnInit {

    @ViewChild('sideNavDiligenciamiento') public sidenav: any;
  	
  	public datosRespuesta:DContextoMuisca;    
    public nombreUsuario:string;
    public nombreOrganizacion:string;
    public precargaCabecera:boolean = true;
    public tiempo:Date;
    public release = environment.release;
    
    /**
    * @constructor
    */
    constructor(
        private dialog: MatDialog,
        private dContextoUsuarioServicio: DContextoUsuarioServicio,
        private dNotificacionServicio:DNotificacionServicio,
        private dlogger:DLogger,
        private _messageObservable: MessageService
    ) {        
        let observableServicio = this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca();
        observableServicio.subscribe(
            res => {
                this.precargaCabecera = false;
                this.datosRespuesta = <DContextoMuisca>res; 
                this.tiempo = new Date();               
                let tiempoReal = new Date();               

                setInterval(()=>{
                    tiempoReal.setSeconds(tiempoReal.getSeconds() + 1);
                    this.tiempo = new Date(tiempoReal);                    
                }, 1000);
            }
        );

        this._messageObservable.getMessage().subscribe(res => {
            switch (res.text) {
                case "openSideNav":
                    this.sidenav.open();
                    break;
            }
        });    
    }   

    ngOnInit(): void {
        console.info('Application environment is set to:', environment.name);
        console.info('Last release timestamp is set to:', environment.release);
    }

    /**
    * @desc Función para enviar un log
    */
    public enviarLog() {
        let dialogo = {
            height: '450px',
            disableClose: true
        };     
        let dialogRef = this.dialog.open(DEnvioLogComponente, dialogo);
        dialogRef.afterClosed().subscribe(result => {
            console.log('Dialog result: ', result);
        });    
    }

    /**
    * @desc Función para redireccionar a un link especifico de Muisca
    */
    public hrefButton (href:string, nuevaPagina?: boolean) {
        if (nuevaPagina) window.open(location.origin + href, '_blank');    
        else window.location.href = location.origin + href;        
    }

    /**
    * @desc Función para hacer el logout de la aplicación
    */
    public logoutApp() {
        this.dContextoUsuarioServicio.logOut();
    } 

    /**
    * @desc Funcion que verifica un observable para validar la session
    */
    private verificarSession() {
        let observer:DObserverTimerSessionApp = new DObserverTimerSessionApp(this.dNotificacionServicio, this.dContextoUsuarioServicio);
        let ObservableTimer = this.dContextoUsuarioServicio.establecerAccionCierreSesionUsuario(observer);
        ObservableTimer.subscribe(
            respuesta  => {
                this.dlogger.info('Accion establecida con cerrar sesión', respuesta);            
            },              
            error =>{  
                this.dlogger.error('Error estableciendo accion de cierre de sesión', error);
            });
    }

}



// WEBPACK FOOTER //
// D:/AngularProjects/Angular Projects/Formularios/src/app/app.component.ts